module.exports = __webpack_public_path__ + "img/cyan_star_cute_face.a5f7e771.png";